<template>
  <div class="subscribe">
    <el-form
      ref="ruleForm"
      :inline="true"
      :model="formLabelAlign"
      :rules="rules"
      :show-message="false"
    >
      <el-form-item prop="concatEmail">
        <el-input
          v-model="formLabelAlign.concatEmail"
          placeholder="请输入您的邮箱"
          clearable
        ></el-input>
        <el-button type="primary" :loading="submitting" @click="subscribe">订阅</el-button>
      </el-form-item>
    </el-form>
    <div class="tips">{{ validInfo }}</div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'SubscribeEmail',
  components: {},
  props: {},
  data() {
    return {
      formLabelAlign: {
        concatEmail: '',
      },
      validInfo: '',
      submitting: false,
    }
  },
  computed: {
    rules() {
      const validateEmail = (rule, value, callback) => {
        const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        if (!emailReg.test(value)) {
          callback(new Error('请输入正确的邮箱地址'))
        } else {
          callback()
        }
      }
      return {
        concatEmail: [
          {
            required: true,
            message: '请输入邮箱地址',
            trigger: 'blur',
          },
          {
            validator: validateEmail,
            trigger: 'blur',
          },
        ],
      }
    },
  },
  watch: {
    $route: {
      handler() {
        this.validInfo = ''
      },
      immediate: true,
    },
  },
  methods: {
    subscribe() {
      if (this.submitting) return
      const email = this.formLabelAlign.concatEmail
      this.$refs.ruleForm.validateField('concatEmail', (valid) => {
        if (valid) {
          this.validInfo = '请输入正确的邮箱地址'
        } else {
          this.submitting = true
          // 调用外部订阅接口：form 提交
          const formData = new FormData()
          formData.append('email', email)
          axios
            .post('https://www.gwlaser.tech/api/smatlas/subscribe', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              timeout: 10000
            })
            .then((res) => {
              const data = res && res.data
              const message = (data && data.m) || '订阅成功，感谢您的关注！'
              this.$message({
                message: message,
                duration: 1500,
                type: data && data.s === false ? 'error' : 'success',
              })
              this.formLabelAlign.concatEmail = ''
              this.validInfo = ''
            })
            .catch((err) => {
              const msg =
                (err && err.response && err.response.data && err.response.data.m) ||
                '订阅失败，请稍后重试'
              this.$message({
                message: msg,
                duration: 1500,
                type: 'error',
              })
            })
            .finally(() => {
              this.submitting = false
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.subscribe {
  .el-button {
    height: 43px;
    background: #123399;
    border: none;
    border-radius: 2px;
  }
  :deep(.el-form-item) {
    width: 100%;
    margin: 0;
  }
  :deep(.el-form-item__content) {
    width: 100%;
    display: flex;
  }
  :deep(.el-input__inner) {
    height: 42px;
  }
  :deep(.el-form-item.is-error) {
    .el-input__inner {
      border-color: transparent;
    }
  }
  .tips {
    font-size: 12px;
    color: #f56c6c;
    min-height: 18px;
    margin-top: 4px;
  }
}
</style>